/**
 * Utility functions for managing task incomplete alert preferences
 */

const LOCALSTORAGE_KEY = "CommsInbox-ChangeTaskAlert-Dismiss";

/**
 * Check if the user has dismissed the task alert
 * @returns true if the modal should be shown, false if user has dismissed it
 */
export const shouldShowTaskIncompleteModal = (): boolean => {
  const dismissFlag = localStorage.getItem(LOCALSTORAGE_KEY);
  return dismissFlag !== "true";
};

/**
 * Save the user's preference to dismiss the task alert
 */
export const setTaskAlertDismissed = (): void => {
  localStorage.setItem(LOCALSTORAGE_KEY, "true");
};

/**
 * Clear the user's preference (useful for testing or resetting)
 */
export const clearTaskAlertPreference = (): void => {
  localStorage.removeItem(LOCALSTORAGE_KEY);
};
